import { Injectable } from '@angular/core';

import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from 'app/app.settings';

export interface IntegratorClient {
	cusId: number;
	cusNameShort: string;
	parentId: number;
	integratorCusId: number;
	integratorCusNameShort: string;
	givState: string;
	adminEmails: string[];
}
export interface Integrator {
	cusId: number;
	nameShort: string;
	nameLong: string;
	adminUsers: string[];
	isSelected?: boolean;
	giaId?: number; // NOTE!!!!! giaId is associate with Integrator's clients. If client's changed, this should also be changed
}

@Injectable()
export class IntegratorService {

	public integrators: Integrator[];

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	getIntegratorClients(customerId?: number) {
		return new Promise<IntegratorClient[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/integratorClient';
			customerId = customerId || this.userService.getUserInfo().customerId;
			const params = {
				customerIdIntegrator: customerId.toString()
			};
			this.requestService.requestGet(url, {
				params: params
			}, (rsp: {data: any[]}) => {
				const clients: IntegratorClient[] = [];
				const promises = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						const cusInfoPromise = new Promise(async (resolveCus, rejectCus) => {
							try {
								const cusInfo = await this.userService.getCustomerInfo(d.gia_cus_id_client, false, true);
								clients.push({
									cusId: d.gia_cus_id_client,
									cusNameShort: d.cus_name_short_client,
									parentId: cusInfo.parentId,
									integratorCusId: d.gia_cus_id_integrator,
									integratorCusNameShort: d.cus_name_short_integrator,
									givState: cusInfo.givState,
									adminEmails: cusInfo.adminEmails
								});
								resolveCus(cusInfo);
							} catch (err) {
								console.log(err);
								rejectCus(err);
							}
						})
						promises.push(cusInfoPromise);
					});
				}
				Promise.all(promises)
				.catch(err => reject(err))
				.then(rsp => {
					clients.sort((a, b) => {
						if (a.cusNameShort < b.cusNameShort) {
							return -1
						} else if (a.cusNameShort > b.cusNameShort) {
							return 1;
						} else {
							return 0;
						}
					});
					this.userService.clients = clients;
					resolve(clients);
				})
			}, err => reject(err));
		})
	}
	addIntegratorClient(integratorCusId: number, clientCusId: number, adminUserId: number) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/integratorClient';
			const body = {
				customerIdIntegrator: integratorCusId,
				customerIdClient: clientCusId,
				sessionOwnerId: adminUserId
			};
			this.requestService.requestPost(url, body, rsp => {
				resolve(rsp);
			}, err => reject(err));
		});
	}
	deleteIntegratorClient(giaId) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/integratorClient';
			this.requestService.requestDelete(url, {
				body: {
					giaId: giaId,
					sessionOwnerId: this.userService.getUserInfo().userId
				}
			}, rsp => resolve(rsp), err => reject(err));
		});
	}
	getIntegrators(clientCustomerId?: number, updateList?: boolean) {
		return new Promise<Integrator[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/integrators';
			const params: any = {}
			if (clientCustomerId) {
				params.customerIdClient = clientCustomerId.toString();
			}
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				const integrators: Integrator[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						const integrator: Integrator = {
							cusId: d.cus_id,
							nameShort: d.cus_name_short,
							nameLong: d.cus_name_long,
							adminUsers: d.admin_users
						};
						if (clientCustomerId) {
							integrator.giaId = d.gia_id;
						}
						integrators.push(integrator);
					});
				}
				if (updateList) {
					this.integrators = integrators;
				}
				resolve(integrators);
			}, err => reject(err));
		});
	}
}
